import type { BillingCycle, Currency } from '@prezly/sdk';

export interface PricingTable {
    id: `${TableId}`;
    options: Option[];
    rows: Row[];
}
export enum TableId {
    STANDARD = 'standard',
    AGENCY = 'agency',
}
export interface Option {
    id: `${OptionId}`;
    display_name: string;
    display_as_package?: boolean;
    description?: string | null | undefined;
    overview: OverviewFeature[];
    prices?: PriceMap;
}
export enum OptionId {
    ESSENTIAL = 'essential',
    STANDARD = 'standard',
    ENTERPRISE = 'enterprise',
    PREMIUM = 'premium',
    AGENCY_ESSENTIAL = 'agency_essential',
    AGENCY_STANARD = 'agency_standard',
    AGENCY_STARTER = 'agency_starter',
    AGENCY_SMALL = 'agency_small',
    AGENCY_MEDIUM = 'agency_medium',
    AGENCY_LARGE = 'agency_large',
    AGENCY_HUGE = 'agency_huge',
}
export interface OverviewFeature {
    name: string;
    details?: string;
}
export type PriceMap = {
    [cycle in `${BillingCycle}`]: {
        [currency in `${Currency.USD | Currency.EUR}`]: number;
    };
};

export interface Row {
    display_name: string;
    description?: string;
    link?: string;
    area?: string;
    status?: 'beta';
    is_key_item: boolean;
    cells: Record<string, Cell>;
}

export type Cell = CheckmarkCell | TextCell | PriceCell;

export type CheckmarkCell = boolean;
export type TextCell = string;
export type PriceCell = {
    [currency in `${Currency.USD | Currency.EUR}`]: string;
};
